import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=5c37e4ce&scoped=true&"
import script from "./AddressItem.vue?vue&type=script&lang=js&"
export * from "./AddressItem.vue?vue&type=script&lang=js&"
import style0 from "./AddressItem.vue?vue&type=style&index=0&id=5c37e4ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c37e4ce",
  null
  
)

export default component.exports